import { render, staticRenderFns } from "./EditPessoavinculoPage.vue?vue&type=template&id=c56e0d42&"
import script from "./EditPessoavinculoPage.vue?vue&type=script&lang=js&"
export * from "./EditPessoavinculoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports